import { useEffect, useState } from 'react';
import { useQuery } from 'data-fetching-client';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { H2 } from 'UIComponents/elements/headings';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UIHelpIcon from 'UIComponents/icon/UIHelpIcon';
import UICopyInput from 'UIComponents/input/UICopyInput';
import UISection from 'UIComponents/section/UISection';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import WebhookPollingContainer from 'automation-ui-enrollment/components/eventEnrollment/steps/WebhookPollingContainer';
import { INITIALIZE_WEBHOOK } from 'automation-ui-enrollment/queries/WebhookQueries';
import UIList from 'UIComponents/list/UIList';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const WebhookConnectToHubSpotStep = ({
  hasExistingWebhookData,
  handleDataReceived,
  setDisableNext,
  setWebhookData
}) => {
  const {
    loading,
    error,
    data,
    refetch
  } = useQuery(INITIALIZE_WEBHOOK);
  const [webhookUrlCopied, setWebhookUrlCopied] = useState(false);
  const refetchUrl = () => {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    refetch();
    setWebhookUrlCopied(false);
    setDisableNext(true);
    setWebhookData({});
  };
  useEffect(() => {
    if (loading || !data) {
      setDisableNext(true);
    }
  }, [loading, data, setDisableNext]);
  if (error) {
    return /*#__PURE__*/_jsx(UISection, {
      children: /*#__PURE__*/_jsx(UIErrorMessage, {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-enrollment.webhookWizard.connectingApp.panelError.title"
        }),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-enrollment.webhookWizard.connectingApp.panelError.description"
        })
      })
    });
  }
  if (loading || !data) {
    return /*#__PURE__*/_jsx(UISection, {
      children: /*#__PURE__*/_jsx(UILoadingSpinner, {
        layout: "centered"
      })
    });
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(UISection, {
      children: [/*#__PURE__*/_jsx(H2, {
        className: "text-center",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-enrollment.webhookWizard.connectingApp.title"
        })
      }), /*#__PURE__*/_jsxs(UIList, {
        ordered: true,
        styled: true,
        childClassName: "m-bottom-2",
        children: [/*#__PURE__*/_jsxs("span", {
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: "automation-ui-enrollment.webhookWizard.connectingApp.steps.copyUrl"
          }), /*#__PURE__*/_jsx(UIFormControl, {
            label: /*#__PURE__*/_jsx(UIHelpIcon, {
              title: /*#__PURE__*/_jsx(FormattedReactMessage, {
                message: "automation-ui-enrollment.webhookWizard.connectingApp.steps.info"
              }),
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "automation-ui-enrollment.webhookWizard.connectingApp.steps.webhookUrl"
              })
            }),
            children: /*#__PURE__*/_jsx(UICopyInput, {
              value: data.initializeWebhook.callbackUrl,
              onClick: () => setWebhookUrlCopied(true)
            })
          })]
        }), /*#__PURE__*/_jsx("span", {
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "automation-ui-enrollment.webhookWizard.connectingApp.steps.goToSettings"
          })
        }), /*#__PURE__*/_jsx("span", {
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "automation-ui-enrollment.webhookWizard.connectingApp.steps.pasteUrl"
          })
        }), /*#__PURE__*/_jsx("span", {
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "automation-ui-enrollment.webhookWizard.connectingApp.steps.sendTestEvent"
          })
        })]
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-enrollment.webhookWizard.connectingApp.description"
      })]
    }), /*#__PURE__*/_jsx(UISection, {
      children: (webhookUrlCopied || hasExistingWebhookData) && /*#__PURE__*/_jsx(WebhookPollingContainer, {
        setDisableNext: setDisableNext,
        hasExistingWebhookData: hasExistingWebhookData,
        refetchUrl: refetchUrl,
        callbackId: data.initializeWebhook.id,
        handleDataReceived: handleDataReceived
      })
    })]
  });
};
export default WebhookConnectToHubSpotStep;